import type { ModuleManifest } from '@eis/core';
import { billingPermissions as p } from './permissions';
import { billingResources } from './i18n';

/**
 * The billing module's single manifest — its one integration point with the shell (backbone §2).
 *
 * The module is the console's surface over the billing service (SDD-015 §7.1): the invoices, one
 * invoice, the bill runs, and the dialogs the insurance pages open through typed link builders and
 * events from `@eis/core` — never by import (backbone §1). It owns the `billing-management`
 * catalog (§7.4) and nothing of the insurance module's.
 *
 * `nav` carries the SAME permission declaration the routes are guarded with, so the menu and the
 * guard cannot drift apart (Addendum A.2). One heading of its own — Abrechnung is neither
 * configuration nor an instance of it; it is what the instance layer owes.
 */
export const billingModule: ModuleManifest = {
  id: 'billing',
  basePath: '/billing',
  routes: () => import('./routes'),
  nav: [
    {
      label: 'billing:nav.invoices',
      icon: 'feather:file-text',
      to: '/billing/invoices',
      section: 'billing:nav.sections.billing',
      permissions: [[p.invoices.view]],
    },
  ],
  i18nNamespaces: ['billing'],
  permissionCatalog: p,
  featureFlagPrefix: 'billing.',
  i18nResources: billingResources,
};
